module.exports = __webpack_public_path__ + "img/ic_girl (1).3ddd3890.png";